import { defineResource, deriveResource } from 'pulse/resources';
import { defaultObjectTypeDefinitionsResolver } from './resolver';
import { keyBy } from '../../utils/keyBy';
import type { ObjectTypeDefinitionParams } from './types';

export const ObjectTypeDefinitions = defineResource({
  typeName: 'hs-resources:ObjectTypeDefinitions',
  resolver: defaultObjectTypeDefinitionsResolver,
}).register();

export const ObjectTypeDefinitionsMap = deriveResource(
  'hs-resources:ObjectTypeDefinitionsMap'
)
  .from(ObjectTypeDefinitions)
  .pull(({ other }) => keyBy(other.data, ({ objectTypeId }) => objectTypeId))
  .push(({ self }) => self.data && Object.values(self.data))
  .register();

export const ObjectTypeDefinition = deriveResource(
  'hs-resources:ObjectTypeDefinition'
)
  .from(ObjectTypeDefinitionsMap)
  .mapParams((__params: ObjectTypeDefinitionParams) => ({}))
  .mergeArgs(['objectTypeId'])
  .pull(({ self, other }) => {
    const objectTypeDefinition = other.data[self.params.objectTypeId];

    if (!objectTypeDefinition) {
      throw new Error(
        `Object type definition ${self.params.objectTypeId} not found`
      );
    }

    return objectTypeDefinition;
  })
  .push(({ self, other }) => {
    if (other.data) {
      other.data[self.params.objectTypeId] = self.data;
    }
  })
  .register();
